const styles = (theme) => ({
  form: {
    margin: "10px",
  },
  buttonContainer: {
    margin: "10px auto",
  },
  label: {
    fontWeight: "bold",
    marginBottom: "10px",
    color: theme.palette.primary.mainColor + "!important",
  },
  labelError: {
    fontWeight: "bold",
    marginBottom: "10px",
    color: "red",
  },
  selectInput: {
    width: "100%",
  },
  customCheckbox: {
    color: theme.palette.primary.main + "!important",
    "&:checked": {
      color: theme.palette.primary.main + "!important",
    },
  },
  customRadio: {
    color: theme.palette.primary.main + "!important",
    "&$checked": {
      color: theme.palette.primary.main + "!important",
    },
  },
  checked: {},
  chip: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
});

export default styles;
